import { observer } from 'mobx-react';
import { TBooleanInNumber } from '~/types/main';
import Switcher from '~/view/components/Controls/Switcher/Switcer';
import Text from '~/view/components/Text/Text';
import { promobannerStore } from '../../store/promobannerStore';
import './style.scss';
import CustomTooltip, { TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import { localeStore } from '~/mobx/localesStore';
import Icon from '~/view/components/Controls/Icon/Icon';
import { Icons } from '~/assets/fonts/Icons/icons';
import { useMemo } from 'react';

const PromoBannerOfferToggle = observer(() => {
  const status = useMemo(
    () => Number(promobannerStore.promobanner.is_shown_as_offer) as TBooleanInNumber,
    [promobannerStore.promobanner.is_shown_as_offer]
  );
  const onChange = (value: TBooleanInNumber) => {
    promobannerStore.changePromobanner({ is_shown_as_offer: Boolean(value) }, true);
  };

  return (
    <div className="promobanner-offer__wrapper mt-6">
      <div className="promobanner-offer__content">
        <Switcher status={status} onChange={onChange} />
        <Text type="switcher-label" text="promobanner_show_as_public_offer_toggle" />

        <CustomTooltip position={TOOLTIP_POSITION.FIXED} message={localeStore.t('promobanner_show_as_public_offer_toggle_infotip')}>
          <Icon name={Icons.Info} className="cursor-pointer color-gray2" size={24} />
        </CustomTooltip>
      </div>
    </div>
  );
});

export default PromoBannerOfferToggle;
